module.exports = __webpack_public_path__ + "img/Eventos_editar_evento.bd5aa29e.svg";